import { Injectable, inject } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import errorMessages from '../../../common/constants/errorMessages';
import { SwalService } from '../../../common/services/swal.service';
import { AuthService } from '../../../features/auth/services/auth.service';
import { SILENT_ERROR_HEADER } from '../../../common/constants/http-headers';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private swalService = inject(SwalService);
  private authService = inject(AuthService);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // Callers that render their own errors opt out of the generic alert
    if (request.headers.has(SILENT_ERROR_HEADER)) {
      return next.handle(request.clone({ headers: request.headers.delete(SILENT_ERROR_HEADER) }));
    }

    return next.handle(request).pipe(
      catchError((e: HttpErrorResponse, x) => {
        console.log('ERROR', e);


        let errorMessage = '';

        if (e.error) {
          switch (e.error.statusCode) {
            case 401:
              errorMessage = errorMessages['401'];
              this.authService.logOut();
              break;

            case 413:
              errorMessage = errorMessages['413'];
              break;

            default:
              errorMessage = errorMessages[e.error.code];
              break;
          }
        }

        if (!errorMessage) {
          errorMessage = e.error?.message || e.error?.error || e.message || 'Error desconocido';
        }

        this.swalService.error(errorMessage);

        return throwError(() => errorMessage);
      }),
    );
  }
}
